import { defineStore } from 'pinia';

const useProgrammeCompetencyStore = defineStore('programmeCompetencyStore', {
  state: () => ({
    competencies: [],
  }),
  actions: {
    clear() {
      this.competencies = [];
    },

    fetchCompetencies(programmeId) {
      this.$logger.info('Fetching competencies', { programmeId }, true);
      return this.$http.get(`/api/curriculum/programmes/${programmeId}/competencies/scores`)
        .then(response => {
          this.competencies = response.data.competencies;
        });
    },
  },
});

export default useProgrammeCompetencyStore;
